import dayjs from 'dayjs'
import { array, object, string } from 'yup'

import { createYupFormResolver } from 'shared/lib/form'
import { validatePhone } from 'shared/lib/validatePhone'

import { parseInsurancePassport } from '../../../model/policy-request'
import {
  InsuranceParticipantData,
  InsurancePolicyholderData,
} from '../../../model/types'

export interface PolicyholderFormValues {
  policyholder: InsurancePolicyholderData
  participants: InsuranceParticipantData[]
}

const requiredText = string().trim().required()
const birthDate = requiredText.test(
  'not-in-future',
  '',
  (value) => !value || !dayjs(value).isAfter(dayjs(), 'day'),
)
const passportNumber = requiredText
  .min(5, '')
  .max(12, '')
  .test(
    'insurance-passport-number',
    '',
    (value) => !value || Boolean(parseInsurancePassport(value)),
  )

const participantSchema = object({
  lastName: requiredText,
  firstName: requiredText,
  inn: requiredText,
  birthDate,
  passportNumber,
  citizenship: object({
    id: string().trim().required(''),
    name: string().trim().required(''),
  })
    .nullable()
    .required(''),
})

const policyholderSchema = participantSchema.concat(
  object({
    citizenship: object({
      id: string().trim().required(''),
      name: string().trim().required(''),
    })
      .nullable()
      .required(''),
    phone: object({
      code: requiredText,
      phone: requiredText,
    }).test('valid-phone', '', (value) => validatePhone(value)),
  }),
)

export const policyholderFormResolver =
  createYupFormResolver<PolicyholderFormValues>(
    object({
      policyholder: policyholderSchema.required(),
      participants: array().of(participantSchema).max(7).required(),
    }),
  )
